export default "__VITE_ASSET__CEenJI3w__"